import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";
import { Permission } from '../models/Permission';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {

    public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/permissions";
    }

    /**Obtiene todas los roles*/
    getRole() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<Permission>(this.url + "/all", { headers: iheaders });
    }

    /**Obtiene todas los usuarios*/
    getAllUser() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<Permission>(this.url + "/alluser", { headers: iheaders });
    }

    /**Obtiene todas los usuarios con pedidos finalizados*/
    getAllUserWhitOrdersFinished() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<Permission>(this.url + "/allUserWhitOrdersFinished", { headers: iheaders });
    }

    /**Obtiene todas los usuarios con pedidos finalizados*/
    getAllUserWhitOrders() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<Permission>(this.url + "/allUserWhitOrders", { headers: iheaders });
    }

    /**Obtiene los roles del usuario*/
    getRoleUser(nid: string) {
       const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
    
        return this.http.get<Permission>(this.url + "/all/"+nid, { headers: iheaders });
    }

    /**Obtiene todas los usuarios de un determinado rol*/
    getUsersRole(PermissionObject: Object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
    
        return this.http.post<Permission>(this.url + "/users",JSON.stringify(PermissionObject), { headers: iheaders });
    }

     /**Obtiene todas los usuarios de un determinado rol*/
     getUsers() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
    
        return this.http.post<Permission>(this.url + "/usersActive", { headers: iheaders });
    }

    /**Guarda permisos del usuario*/
    postSave(PermissionObject: Object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<Permission>(this.url + "/save", JSON.stringify(PermissionObject), { headers: iheaders });
    }

    /**Borrar permisos a un usuario*/
    postDelete(PermissionObject: Object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<Permission>(this.url + "/delete", JSON.stringify(PermissionObject), { headers: iheaders });
    }
}
